import React, { useContext, useRef } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import '../../../css/QuestionFlyout.scss';
import { register } from '../../../i18n';

import useAccessibilityClick from '../../../hooks/useAccessibilityClick';

const SatelliteToggle = observer(() => {
	const t = register('PanelMenu');
	const {
		lessonManager,
		toolbarManager
	} = useContext(MobXProviderContext);

	const openButtonRef = useRef();

	useAccessibilityClick(openButtonRef, () => {
		const nextIsOpen = !lessonManager.isSatelliteOpen;
		lessonManager.setIsSatelliteOpen(nextIsOpen);
		if (nextIsOpen) {
			window.parent.postMessage({ type: 'open_satellite' }, toolbarManager.externalUrl);
		} else {
			window.parent.postMessage({ type: 'close_satellite' }, toolbarManager.externalUrl);
		}
	});

	if (!lessonManager.shouldShowRelatedTabButton) {
		return null;
	}

	return (
		<div
			className={classNames('q-flyout-wrapper', 'satellite-toggle', {
				left: true,
				open: lessonManager.isSatelliteOpen,
				closed: !lessonManager.isSatelliteOpen
			})}
		>
			<div className={classNames({ 'q-flyout-tab-bar': true })}>
				<div
					ref={openButtonRef}
					aria-controls={'related-resources-panel'}
					aria-label={!lessonManager.isSatelliteOpen ? t('openRelatedResources', 'Open Related Resources') : t('closeRelatedResources', 'Close Related Resources')}
					aria-selected={lessonManager.isSatelliteOpen}
					className='q-flyout-tab open-button-wrapper satellite-toggle-button'
					role='tab'
					tabIndex='0'
				>
					<div className='q-flyout-tab-label'>{t('relatedResources', 'Related Resources')}</div>
				</div>
			</div>
		</div>
	);
});

export default SatelliteToggle;
